module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-our-office"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading) ? _c('div', [_c('HeroPage', {
    attrs: {
      "props": _vm.props.acf.hero_page
    }
  }), _c('TabOfficeDoctor', {
    attrs: {
      "id": "doctor",
      "props": _vm.props.acf.tab_office_doctor
    }
  }), _c('CustomOfficeFamily', {
    attrs: {
      "props": _vm.props.acf.custom_office_family
    }
  }), _c('CustomOfficeBanner', {
    attrs: {
      "id": "team",
      "props": _vm.props.acf.banner
    }
  }), _c('CustomOfficeTeam', {
    attrs: {
      "props": _vm.props.acf.custom_office_team
    }
  }), _c('CustomOfficeTour', {
    attrs: {
      "id": "tour",
      "props": _vm.props.acf.tour
    }
  }), _c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry",
      value: (_vm.containerId),
      expression: "containerId"
    }],
    staticClass: "row",
    attrs: {
      "transition-duration": "0.3s",
      "item-selector": ".item"
    }
  }, _vm._l((_vm.props.images), function(image, index) {
    return _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile",
        value: (_vm.v - _vm.masonry - _vm.tile),
        expression: "v-masonry-tile"
      }],
      staticClass: "item"
    })
  })), _c('CustomPatientInsurance', {
    attrs: {
      "id": "kids",
      "props": _vm.props.acf.kids
    }
  }), _c('CustomPatientKidsClub', {
    attrs: {
      "props": _vm.props.acf.custom_patient_lucas_kids_club
    }
  }), _c('CustomOfficeContest', {
    attrs: {
      "id": "contest",
      "props": _vm.props.acf.contest_two
    }
  }), _c('CustomOfficeContest', {
    attrs: {
      "props": _vm.props.acf.contest
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d77be7e6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/our-office/our-office.pug
// module id = 667
// module chunks = 1